export const SOURCE_SPECIFIC_FIELDS = {
	VIBER: ['templateId', 'customFieldsJson'],
	WHATSAPP: ['templateId']
};